// const popularBackrest = ['seat_5', 'seat_1']
const popularBackrest = []
const backrests = ['seat_5', 'seat_8', 'seat_3', 'seat_1',  'seat_6',  'seat_9'].map((node, key) => ({
// const backrests = ['seat_5', 'seat_8'].map((node) => ({
  node,
  mostPopular: popularBackrest.includes(node),
  buttonImage: require(`../img/${node}.png`),
  buttonName: node.split('_')[1],
  price: (key > 1 ? 950 : 0)
}))

export default backrests
